export const organizationType = {
    'For profit company': 'PRIVATE',
    'Non-profit': 'NON_PROFIT',
    'Academic institution': 'ACADEMIC',
    Charity: 'CHARITY',
};

export const businessOperateList = [
    'Alberta',
    'British Columbia',
    'Manitoba',
    'New Brunswick',
    'Newfoundland and Labrador',
    'Northwest Territories',
    'Nova Scotia',
    'Nunavut',
    'Ontario',
    'Prince Edward Island',
    'Quebec',
    'Saskatchewan',
    'Yukon',
];

export const organizationIndustryOptions = [
    'Hospitality / Restaurant',
    'Retail',
    'Construction',
    'Transportation / Trucking',
    'Manufacturing',
    'IT / Technology',
    'Healthcare',
    'Agriculture',
    'Education',
    'Other',
];

export const everBannedOrRestrictedValues = ['Yes', 'No', 'Not sure'];

export const organizationAnnualRevenue = [
    'Less than $100,000',
    '$100,000 – $500,000',
    '$500,000 – $1 Million',
    'More than $1 Million',
];
